import {
  CREATE_ADDITIONAL_FIELD,
  CREATE_ADDITIONAL_FIELDS_SUCCESS,
  GET_ADDITIONAL_FIELDS,
  GET_ADDITIONAL_FIELD,
  SET_ADDITIONAL_FIELDS,
  SET_ADDITIONAL_FIELD,
  SET_ADDITIONAL_FIELDS_STATUS,
  EDIT_ADDITIONAL_FIELD,
  EDIT_ADDITIONAL_FIELD_SUCCESS,
  RESET_ADDITIONAL_FIELDS,
  ACTIVATE_ADDITIONAL_FIELD,
  ACTIVATE_ADDITIONAL_FIELD_SUCCESS,
  API_ERROR,
  RESET_ERROR,
} from "./actionTypes";

const initialState = {
  errorAdditionalFields: false,
  loadingAdditionalFields: false,
  dataAdditionalFields: null,
  successAdditionalFields: false,
};

const AdditionalFields = (state = initialState, action) => {
  switch (action.type) {
    case RESET_ADDITIONAL_FIELDS:
      state = {
        ...state,
        errorAdditionalFields: false,
        loadingAdditionalFields: false,
        loadingAdditionalFieldsDelete: false,
        successAdditionalFields: false,
        dataAdditionalFields: null,
        dataAdditionalFieldsDelete: null,
        dataAdditionalFieldsEditCreate: null,
        loadingAdditionalFieldsEditCreate: false,
      };
      break;
    // case RESET_AdditionalFields:
    //   state = {
    //     ...state,
    //     errorAdditionalFields: false,
    //     loadingAdditionalFields: false,
    //     successAdditionalFields: false,
    //     dataAdditionalFieldsGetSet: null,
    //     dataAdditionalFieldsEditCreate: null,
    //   };
    //   break;
    case RESET_ERROR:
      state = {
        ...state,
        errorAdditionalFields: false,
        loadingAdditionalFields: false,
        loadingAdditionalFieldsEditCreate: false,
        loadingAdditionalFieldsActivate: false,
        successAdditionalFields: false,
      };
      break;
    case GET_ADDITIONAL_FIELDS:
      state = {
        ...state,
        errorAdditionalFields: false,
        loadingAdditionalFields: true,
        dataAdditionalFields: null,
      };
      break;
    case SET_ADDITIONAL_FIELDS:
      state = {
        ...state,
        errorAdditionalFields: false,
        loadingAdditionalFields: false,
        dataAdditionalFields: action.payload,
      };
      break;
    case CREATE_ADDITIONAL_FIELD:
      state = {
        ...state,
        errorAdditionalFields: false,
        loadingAdditionalFieldsEditCreate: true,
        dataAdditionalFieldsEditCreate: action.payload,
        successAdditionalFields: false,
      };
      break;
    case CREATE_ADDITIONAL_FIELDS_SUCCESS:
      state = {
        ...state,
        errorAdditionalFields: false,
        loadingAdditionalFieldsEditCreate: false,
        dataAdditionalFieldsEditCreate: action.payload,
        successAdditionalFields: true,
      };
      break;
    case ACTIVATE_ADDITIONAL_FIELD:
      state = {
        ...state,
        errorAdditionalFields: false,
        loadingAdditionalFieldsEditCreate: true,
        dataAdditionalFieldsEditCreate: action.payload,
        successAdditionalFields: false,
      };
      break;
    case ACTIVATE_ADDITIONAL_FIELD_SUCCESS:
      state = {
        ...state,
        errorAdditionalFields: false,
        loadingAdditionalFieldsEditCreate: false,
        dataAdditionalFieldsEditCreate: action.payload,
        successAdditionalFields: true,
      };
      break;
    case GET_ADDITIONAL_FIELD:
      state = {
        ...state,
        errorAdditionalField: false,
        loadingAdditionalField: true,
        dataAdditionalFieldsGetSet: null,
      };
      break;
    case SET_ADDITIONAL_FIELD:
      state = {
        ...state,
        errorAdditionalField: false,
        loadingAdditionalField: false,
        dataAdditionalFieldsGetSet: action.payload,
      };
      break;
    case EDIT_ADDITIONAL_FIELD:
      state = {
        ...state,
        errorAdditionalFields: false,
        loadingAdditionalFieldsEditCreate: true,
        dataAdditionalFieldsEditCreate: action.payload,
        successAdditionalFields: false,
      };
      break;
    case EDIT_ADDITIONAL_FIELD_SUCCESS:
      state = {
        ...state,
        errorAdditionalFields: false,
        loadingAdditionalFieldsEditCreate: false,
        dataAdditionalFieldsEditCreate: action.payload,
        successAdditionalFields: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorAdditionalFields: action.payload,
        loadingAdditionalFields: false,
        loadingAdditionalFieldsDelete: false,
        successAdditionalFields: false,
      };
      break;
    // case DELETE_AdditionalFields:
    //   state = {
    //     ...state,
    //     errorAdditionalFields: false,
    //     loadingAdditionalFieldsDelete: true,
    //     dataAdditionalFieldsDelete: action.payload,
    //     successAdditionalFields: false,
    //   };
    //   break;
    // case DELETE_AdditionalFields_SUCCESS:
    //   state = {
    //     ...state,
    //     errorAdditionalFields: false,
    //     loadingAdditionalFieldsDelete: false,
    //     dataAdditionalFieldsDelete: action.payload,
    //     successAdditionalFields: true,
    //   };
    //   break;
    default:
      // state = { ...state, errorAdditionalFields: false, loadingAdditionalFields: false };
      break;
  }
  return state;
};

export default AdditionalFields;
